<template>
  <div class="side_nav_wrapper" :class="{ active: navIsActive }">
    <!-- Start:: Toggle Btn -->
    <button class="close_btn" @click="$emit('fireToggleNavDrawerEmit')">
      <i class="fal fa-times"></i>
    </button>
    <!-- End:: Toggle Btn -->

    <!-- Start:: Logo -->
    <div class="logo_wrapper" v-if="getAppTheme == 'light_theme'">
      <router-link class="logo" to="/home">
        <img
          src="@/assets/media/logo/logo.png"
          alt="Logo"
          width="170"
          height="125"
        />
      </router-link>
    </div>

    <div class="logo_wrapper" v-else>
      <router-link class="logo" to="/home">
        <img
          src="@/assets/media/logo/logo_dark.svg"
          alt="Logo"
          width="170"
          height="125"
        />
      </router-link>
    </div>
    <!-- End:: Logo -->

    <!-- Start:: Side Nav Links -->
    <div class="side_nav_links_wrapper">
      <div class="nav_section">
        <p class="section_title">{{ $t("SIDENAV.sectionTitles.overview") }}</p>
        <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')">
          <router-link to="/home">
            <span class="route_icon">
              <img
                src="@/assets/media/icons/ui_icons/home.svg"
                alt="icon"
                width="40"
                height="40"
              />
            </span>
            <span class="route_text">
              {{ $t("SIDENAV.dashboard") }}
            </span>
          </router-link>
        </div>
      </div>

      <div class="nav_section" v-if="hasUserManagementSection">
        <p class="section_title">
          {{ $t("SIDENAV.sectionTitles.user_management") }}
        </p>
        <div
          v-if="
            $can('roles index', 'roles') ||
            $can('permissions index', 'permissions') ||
            $can('admin index', 'admin')
          "
          class="side_routes_wrapper"
        >
          <a-menu
            style="width: 100%"
            mode="vertical"
            :open-keys="openKeys"
            @openChange="onOpenChange"
          >
            <a-sub-menu
              v-for="item in sideNavbarList_Admins"
              :key="item.key"
              :data-type="!item.children ? 'single_route' : ''"
            >
              <template v-if="item.children">
                <span slot="title">
                  <img :src="item.icon" alt="icon" width="35" height="35" />
                  <span> {{ item.title }} </span>
                </span>

                <a-menu-item
                  v-for="childItem in item.children"
                  :key="childItem.key"
                >
                  <button
                    v-if="childItem.hasPermission"
                    class="text-start w-100"
                    @click="$emit('fireToggleNavDrawerEmit')"
                  >
                    <router-link :to="childItem.route">
                      <i class="fad fa-circle"></i>
                      {{ childItem.title }}
                    </router-link>
                  </button>
                </a-menu-item>
              </template>
            </a-sub-menu>
          </a-menu>
        </div>

        <div
          class="side_routes_wrapper"
          v-if="$can('provider index', 'provider')"
        >
          <a-menu
            style="width: 100%"
            mode="vertical"
            :open-keys="openKeys"
            @openChange="onOpenChange"
          >
            <a-sub-menu
              v-for="item in sideNavbarList_providers"
              :key="item.key"
              :data-type="!item.children ? 'single_route' : ''"
              style="border: none"
            >
              <template v-if="item.children">
                <span slot="title">
                  <img :src="item.icon" alt="icon" width="35" height="35" />
                  <span> {{ item.title }} </span>
                </span>

                <a-menu-item
                  v-for="childItem in item.children"
                  :key="childItem.key"
                >
                  <button
                    v-if="childItem.hasPermission"
                    class="text-start w-100"
                    @click="$emit('fireToggleNavDrawerEmit')"
                  >
                    <router-link :to="childItem.route">
                      <i class="fad fa-circle"></i>
                      {{ childItem.title }}
                    </router-link>
                  </button>
                </a-menu-item>
              </template>
            </a-sub-menu>
          </a-menu>
        </div>

        <div
          class="home_route"
          @click="$emit('fireToggleNavDrawerEmit')"
          v-if="$can('distrbutionpoint index', 'distrbutionpoint')"
        >
          <router-link to="/DistrbutionPoints/all">
            <span class="route_icon">
              <img
                src="@/assets/media/icons/ui_icons/distribution.png"
                alt="icon"
                width="40"
                height="40"
              />
            </span>
            <span class="route_text">
              {{ $t("PLACEHOLDERS.distrbutionpoint") }}
            </span>
          </router-link>
        </div>
      </div>

      <div class="nav_section" v-if="hasOperationsSection">
        <p class="section_title">
          {{ $t("SIDENAV.sectionTitles.operations") }}
        </p>
        <div
          class="home_route"
          @click="$emit('fireToggleNavDrawerEmit')"
          v-if="$can('deliveries index', 'deliveries')"
        >
          <router-link to="/DeliveryMen/all">
            <span class="route_icon">
              <img
                src="@/assets/media/icons/ui_icons/shipment.svg"
                alt="icon"
                width="40"
                height="40"
              />
            </span>
            <span class="route_text">
              {{ $t("SIDENAV.DeliveryMen.title") }}
            </span>
          </router-link>
        </div>

        <div class="side_routes_wrapper" v-if="$can('driver index', 'driver')">
          <a-menu
            style="width: 100%"
            mode="vertical"
            :open-keys="openKeys"
            @openChange="onOpenChange"
          >
            <a-sub-menu
              v-for="item in sideNavbarList_deliveries"
              :key="item.key"
              :data-type="!item.children ? 'single_route' : ''"
              style="border: none"
            >
              <template v-if="item.children">
                <span slot="title">
                  <img :src="item.icon" alt="icon" width="35" height="35" />
                  <span> {{ item.title }} </span>
                </span>

                <a-menu-item
                  v-for="childItem in item.children"
                  :key="childItem.key"
                >
                  <button
                    v-if="childItem.hasPermission"
                    class="text-start w-100"
                    @click="$emit('fireToggleNavDrawerEmit')"
                  >
                    <router-link :to="childItem.route">
                      <i class="fad fa-circle"></i>
                      {{ childItem.title }}
                    </router-link>
                  </button>
                </a-menu-item>
              </template>
            </a-sub-menu>
          </a-menu>
        </div>

        <div
          class="home_route"
          v-if="$can('driver index', 'driver')"
          @click="$emit('fireToggleNavDrawerEmit')"
        >
          <router-link to="/delegates/all">
            <span class="route_icon">
              <img
                src="@/assets/media/icons/ui_icons/clients.svg"
                alt="icon"
                width="40"
                height="40"
              />
            </span>
            <span class="route_text">
              {{ $t("PLACEHOLDERS.delegates_live_management") }}
            </span>
          </router-link>
        </div>

        <div
          v-if="$can('bundle index', 'bundle')"
          class="home_route"
          @click="$emit('fireToggleNavDrawerEmit')"
        >
          <router-link to="/bundles/all">
            <span class="route_icon">
              <img
                src="@/assets/media/icons/ui_icons/box.svg"
                alt="icon"
                width="40"
                height="40"
              />
            </span>
            <span class="route_text">
              {{ $t("PLACEHOLDERS.bundle_management") }}
            </span>
          </router-link>
        </div>
      </div>

      <div class="nav_section" v-if="hasFinancialSection">
        <p class="section_title">
          {{ $t("SIDENAV.sectionTitles.financials") }}
        </p>
        <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')">
          <router-link to="/driver-withdrawal-requests/all">
            <span class="route_icon">
              <img
                src="@/assets/media/icons/ui_icons/cashless-payment.png"
                alt="icon"
                width="40"
                height="40"
              />
            </span>
            <span class="route_text">
              {{ $t("SIDENAV.DriverWithdrawalRequests.title") }}
            </span>
          </router-link>
        </div>

        <div
          class="home_route"
          @click="$emit('fireToggleNavDrawerEmit')"
          v-if="$can('reports index', 'reports')"
        >
          <router-link to="/distribution-points-withdrawal-requests/all">
            <span class="route_icon">
              <img
                src="@/assets/media/icons/ui_icons/money-flow.png"
                alt="icon"
                width="40"
                height="40"
              />
            </span>
            <span class="route_text">
              {{ $t("SIDENAV.DistributionPointsWithdrawalRequests.title") }}
            </span>
          </router-link>
        </div>

        <div
          v-if="$can('reports index', 'reports')"
          class="home_route"
          @click="$emit('fireToggleNavDrawerEmit')"
        >
          <router-link to="/drivers-reports/all">
            <span class="route_icon">
              <img
                src="@/assets/media/icons/ui_icons/reports.png"
                alt="icon"
                width="40"
                height="40"
              />
            </span>
            <span class="route_text">
              {{ $t("PLACEHOLDERS.driver_reports") }}
            </span>
          </router-link>
        </div>

        <div
          class="home_route"
          @click="$emit('fireToggleNavDrawerEmit')"
          v-if="$can('reports index', 'reports')"
        >
          <router-link to="/providers-reports/all">
            <span class="route_icon">
              <img
                src="@/assets/media/icons/ui_icons/reports.png"
                alt="icon"
                width="40"
                height="40"
              />
            </span>
            <span class="route_text">
              {{ $t("PLACEHOLDERS.provider_reports") }}
            </span>
          </router-link>
        </div>

        <div
          class="home_route"
          @click="$emit('fireToggleNavDrawerEmit')"
          v-if="$can('reports index', 'reports')"
        >
          <router-link to="/bundles-reports/all">
            <span class="route_icon">
              <img
                src="@/assets/media/icons/ui_icons/reports.png"
                alt="icon"
                width="40"
                height="40"
              />
            </span>
            <span class="route_text">
              {{ $t("PLACEHOLDERS.bundles_reports") }}
            </span>
          </router-link>
        </div>

        <div
          class="home_route"
          @click="$emit('fireToggleNavDrawerEmit')"
          v-if="$can('reports index', 'reports')"
        >
          <router-link to="/financial-reports/all">
            <span class="route_icon">
              <img
                src="@/assets/media/icons/ui_icons/bill.svg"
                alt="icon"
                width="40"
                height="40"
              />
            </span>
            <span class="route_text">
              {{ $t("PLACEHOLDERS.financial_reports") }}
            </span>
          </router-link>
        </div>
      </div>

      <div class="nav_section" v-if="hasSystemSection">
        <p class="section_title">
          {{ $t("SIDENAV.sectionTitles.settings_and_communication") }}
        </p>
        <div
          v-if="$can('notifications index', 'notifications')"
          class="home_route"
          @click="$emit('fireToggleNavDrawerEmit')"
        >
          <router-link to="/all-notifications/all">
            <span class="route_icon">
              <img
                src="@/assets/media/icons/ui_icons/notifications.svg"
                alt="icon"
                width="40"
                height="40"
              />
            </span>
            <span class="route_text">
              {{ $t("SIDENAV.notifications.title") }}
            </span>
          </router-link>
        </div>

        <div
          class="home_route"
          @click="$emit('fireToggleNavDrawerEmit')"
          v-if="$can('settings index', 'settings')"
        >
          <router-link to="/app_settings">
            <span class="route_icon">
              <img
                src="@/assets/media/icons/ui_icons/settings.svg"
                alt="icon"
                width="40"
                height="40"
              />
            </span>
            <span class="route_text">
              {{ $t("SIDENAV.settings.general_app") }}
            </span>
          </router-link>
        </div>

        <div
          class="side_routes_wrapper"
          v-if="$can('settings index', 'settings')"
        >
          <a-menu
            style="width: 100%"
            mode="vertical"
            :open-keys="openKeys"
            @openChange="onOpenChange"
          >
            <a-sub-menu
              v-for="item in sideNavbarList"
              :key="item.key"
              :data-type="!item.children ? 'single_route' : ''"
              style="border: none"
            >
              <template v-if="item.children">
                <span slot="title">
                  <img :src="item.icon" alt="icon" width="35" height="35" />
                  <span> {{ item.title }} </span>
                </span>

                <a-menu-item
                  v-for="childItem in item.children"
                  :key="childItem.key"
                >
                  <button
                    class="text-start w-100"
                    @click="$emit('fireToggleNavDrawerEmit')"
                    v-if="childItem.hasPermission"
                  >
                    <router-link :to="childItem.route">
                      <i class="fad fa-circle"></i>
                      {{ childItem.title }}
                    </router-link>
                  </button>
                </a-menu-item>
              </template>
            </a-sub-menu>
          </a-menu>
        </div>
      </div>

      <div class="side_routes_wrapper">
        <a-menu style="width: 100%" mode="inline">
          <!-- Start:: Logout Tab -->
          <a-sub-menu
            key="logout"
            @titleClick="logoutConfirmationModalIsOpen = true"
          >
            <!-- ========= Start:: Main Tab -->
            <span slot="title" class="logout_btn">
              <img
                src="../../assets/media/icons/ui_icons/logout.svg"
                alt="icon"
                width="35"
                height="35"
              />
              <span>
                {{ $t("SIDENAV.Logout.title") }}
              </span>
            </span>
            <!-- ========= End:: Main Tab -->
          </a-sub-menu>
          <!-- End:: Logout Tab -->
        </a-menu>
      </div>
      <!-- End:: Side Nav Routes -->

      <!-- Start:: Logout Confirmation Modal -->
      <v-dialog v-model="logoutConfirmationModalIsOpen">
        <v-card>
          <v-card-title class="text-h5 justify-center">
            {{ $t("TITLES.logoutConfirmingMessage") }}
          </v-card-title>
          <v-card-actions>
            <v-btn class="modal_confirm_btn" @click="logout">{{
              $t("BUTTONS.logout")
            }}</v-btn>

            <v-btn
              class="modal_cancel_btn"
              @click="logoutConfirmationModalIsOpen = false"
              >{{ $t("BUTTONS.cancel") }}</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- End:: Logout Confirmation Modal -->
    </div>
  </div>
  <!-- End:: Side Nav Links -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SideNav",

  emits: ["fireToggleNavDrawerEmit"],

  props: {
    navIsActive: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    // Start:: Vuex Get Authenticated User Data
    ...mapGetters({
      getAppTheme: "AppThemeModule/getAppTheme",
      getAuthenticatedUserData: "AuthenticationModule/getAuthenticatedUserData",
    }),
    // End:: Vuex Get Authenticated User Data

    // Start:: Extract Side Nav Keys
    extractSideNavItemsKeys() {
      let extractedKeys = [];
      this.sideNavbarList_Admins.forEach((element) => {
        extractedKeys.push(element["key"]);
      });
      this.sideNavbarList_Places.forEach((element) => {
        extractedKeys.push(element["key"]);
      });
      this.sideNavbarList.forEach((element) => {
        extractedKeys.push(element["key"]);
      });
      this.sideNavbarList_Rates.forEach((element) => {
        extractedKeys.push(element["key"]);
      });
      this.sideNavbarList_deliveries.forEach((element) => {
        extractedKeys.push(element["key"]);
      });
      this.sideNavbarList_providers.forEach((element) => {
        extractedKeys.push(element["key"]);
      });
      return extractedKeys;
    },

    hasUserManagementSection() {
      return (
        this.$can("roles index", "roles") ||
        this.$can("permissions index", "permissions") ||
        this.$can("admin index", "admin") ||
        this.$can("provider index", "provider") ||
        this.$can("distrbutionpoint index", "distrbutionpoint")
      );
    },

    hasOperationsSection() {
      return (
        this.$can("deliveries index", "deliveries") ||
        this.$can("driver index", "driver") ||
        this.$can("bundle index", "bundle")
      );
    },

    hasFinancialSection() {
      return true;
    },

    hasSystemSection() {
      return (
        this.$can("notifications index", "notifications") ||
        this.$can("settings index", "settings")
      );
    },

    // End:: Extract Side Nav Keys
  },

  data() {
    return {
      // Start:: Controle Open Tabs Data
      openKeys: [],
      // End:: Controle Open Tabs Data

      // Start:: Side Navbar List
      sideNavbarList_Admins: [
        {
          key: "dashboard",
          title: this.$t("SIDENAV.control_admins"),
          icon: require("@/assets/media/icons/ui_icons/panel.png"),
          hasPermission: this.$can("roles index", "roles"),
          children: [
            {
              key: "roles",
              title: this.$t("SIDENAV.Roles.title"),
              route: "/roles/all",
              hasPermission: this.$can("roles index", "roles"),
            },
            {
              key: "admins",
              title: this.$t("SIDENAV.Admins.title"),
              route: "/admins/all",
              hasPermission: this.$can("admin index", "admin"),
            },
          ],
        },
      ],

      sideNavbarList_Places: [
        {
          key: "dashboard_places",
          title: this.$t("PLACEHOLDERS.places"),
          icon: require("@/assets/media/icons/ui_icons/country.png"),
          hasPermission:
            this.$can("regions index", "regions") ||
            this.$can("cities index", "cities"),
          children: [
            {
              key: "regions",
              title: this.$t("PLACEHOLDERS.manage_regions"),
              route: "/areas/all",
              hasPermission: this.$can("regions index", "regions"),
            },
            // {
            //   key: "cities",
            //   title: this.$t("PLACEHOLDERS.cities"),
            //   route: "/cities/all",
            //   hasPermission: this.$can("cities index", "cities"),
            // },
          ],
        },
      ],

      sideNavbarList_users: [
        {
          key: "users_control",
          title: this.$t("PLACEHOLDERS.manage_users"),
          icon: require("@/assets/media/icons/ui_icons/clients.svg"),
          hasPermission: this.$can("users index", "users"),
          children: [
            {
              key: "users",
              title: this.$t("PLACEHOLDERS.manage_all_users"),
              route: "/clients/all",
              hasPermission: this.$can("users index", "users"),
            },
          ],
        },
      ],

      sideNavbarList: [
        {
          key: "appContent",
          title: this.$t("SIDENAV.AppContent.title"),
          icon: require("@/assets/media/icons/ui_icons/book_mark.svg"),
          children: [
            // {
            //   key: "contact-messages",
            //   title: this.$t("SIDENAV.ContactMessages.title"),
            //   route: "/contact-messages/all",
            //   hasPermission: this.$can("contacts index", "contacts"),
            // },
            {
              key: "contact",
              title: this.$t("PLACEHOLDERS.contact_admins"),
              route: "/contact_settings",
              hasPermission: this.$can("settings create", "settings"),
            },
            {
              key: "AboutUs",
              title: this.$t("SIDENAV.AppContent.aboutUs"),
              route: "/app-content/about-us",
              hasPermission: this.$can("settings create", "settings"),
            },
            {
              key: "termsAndConditions",
              title: this.$t("SIDENAV.AppContent.termsAndConditions"),
              route: "/app-content/terms",
              hasPermission: this.$can("settings create", "settings"),
            },
            {
              key: "privacyPolicy",
              title: this.$t("SIDENAV.AppContent.privacyPolicy"),
              route: "/app-content/policy",
              hasPermission: this.$can("settings create", "settings"),
            },
            {
              key: "returnPolicy",
              title: this.$t("PLACEHOLDERS.returnPolicy"),
              route: "/app-content/return-policy",
              hasPermission: this.$can("settings create", "settings"),
            },
            // {
            //   key: "provider-terms",
            //   title: this.$t("PLACEHOLDERS.terms_and_conditions_policy"),
            //   route: "/app-content/provider-terms",
            //   hasPermission: this.$can("settings create", "settings"),
            // },
            {
              key: "delete-account",
              title: this.$t("PLACEHOLDERS.how_to_delete_account"),
              route: "/app-content/delete-account",
              hasPermission: this.$can("settings create", "settings"),
            },
            // {
            //   key: "faq",
            //   title: this.$t("PLACEHOLDERS.faq"),
            //   route: "/app-content/faq",
            //   hasPermission: this.$can("settings create", "settings"),
            // },
          ],
        },
      ],

      sideNavbarList_Rates: [
        {
          key: "rates",
          title: this.$t("PLACEHOLDERS.comments_management"),
          icon: require("@/assets/media/icons/ui_icons/star.svg"),
          hasPermission: this.$can("rates index", "rates"),
          children: [
            {
              key: "app_rate",
              title: this.$t("PLACEHOLDERS.app_ratings"),
              route: "/app-rate/all",
              hasPermission: this.$can("rates apprates", "rates"),
            },
            {
              key: "store_rate",
              title: this.$t("PLACEHOLDERS.store_ratings"),
              route: "/store-rate/all",
              hasPermission: this.$can("rates salonrates", "rates"),
            },
          ],
        },
      ],

      sideNavbarFinancial: [
        {
          key: "financial",
          title: this.$t("PLACEHOLDERS.financial_reports"),
          icon: require("@/assets/media/icons/ui_icons/cashless-payment.png"),
          hasPermission: this.$can(
            "financialreports index",
            "financialreports"
          ),

          children: [
            {
              key: "financial-reports-unfinished",
              title: this.$t("PLACEHOLDERS.unfinished_orders"),
              route: "/financial-reports/all",
              hasPermission: this.$can(
                "financialreports index",
                "financialreports"
              ),
            },
            {
              key: "financial-reports",
              title: this.$t("PLACEHOLDERS.finished_orders"),
              route: "/financial-finished-reports/all",
              hasPermission: this.$can(
                "financialreports index",
                "financialreports"
              ),
            },
          ],
        },
      ],

      sideNavbarList_deliveries: [
        {
          key: "deliveries",
          title: this.$t("PLACEHOLDERS.deliveries_management"),
          icon: require("@/assets/media/icons/ui_icons/delivery.png"),
          hasPermission: this.$can("driver index", "driver"),
          children: [
            {
              key: "join_deliveries",
              title: this.$t("PLACEHOLDERS.join_deliveries"),
              route: "/join_deliveries/all",
              hasPermission: this.$can("driver index", "driver"),
            },
            {
              key: "DeliveryMen",
              title: this.$t("PLACEHOLDERS.DeliveryMen"),
              route: "/DeliveryMen/all",
              hasPermission: this.$can("driver index", "driver"),
            },
          ],
        },
      ],
      sideNavbarList_providers: [
        {
          key: "providers",
          title: this.$t("PLACEHOLDERS.control_admins"),
          icon: require("@/assets/media/icons/ui_icons/manager.png"),
          hasPermission: this.$can("provider index", "provider"),
          children: [
            {
              key: "providers_list",
              title: this.$t("PLACEHOLDERS.control_admins"),
              route: "/providers/all",
              hasPermission: this.$can("provider index", "provider"),
            },
            {
              key: "join_providers",
              title: this.$t("PLACEHOLDERS.admins-join-request"),
              route: "/join_providers/all",
              hasPermission: this.$can("provider index", "provider"),
            },
          ],
        },
      ],

      // Start:: Modal Controlling Data
      logoutConfirmationModalIsOpen: false,
      // End:: Modal Controlling Data
    };
  },

  methods: {
    // Start:: Vuex Auth Actions
    ...mapActions({
      logout: "AuthenticationModule/logout",
    }),
    // End:: Vuex Auth Actions
    handleClick() {
      this.open = !this.open;
    },
    closeMenu() {
      this.open = false;
    },

    handleClickOrder() {
      this.openOrder = !this.openOrder;
    },
    closeMenuOrder() {
      this.openOrder = false;
    },
    handleClickcities() {
      this.openCities = !this.openCities;
    },
    closeMenuCities() {
      this.openCities = false;
    },
    // Start:: Controle Open Tabs
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );
      if (this.extractSideNavItemsKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    // End:: Controle Open Tabs
  },

  created() {},
};
</script>

<style scoped>
.nav_section {
  margin-bottom: 1rem;
}

.section_title {
  margin: 0.5rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  opacity: 0.7;
}
</style>
